import { render, staticRenderFns } from "./DepartmentReviews.vue?vue&type=template&id=6e67f8d8&scoped=true"
import script from "./DepartmentReviews.vue?vue&type=script&lang=js"
export * from "./DepartmentReviews.vue?vue&type=script&lang=js"
import style0 from "./DepartmentReviews.vue?vue&type=style&index=0&id=6e67f8d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67f8d8",
  null
  
)

export default component.exports